// btw-front/src/lib/adminPartnerSearch.js
// 관리자 [파트너] 탭 통합 검색 — 회사(회사명·사업자번호) + 소속 계정(아이디·이름·이메일).
// 사업자번호는 DB 에 하이픈 없이 저장되지만 관리자는 사업자등록증·문서에서 하이픈 포함 형태로
// 복사해 붙이는 경우가 많다 → 저장값과 검색어 양쪽에서 하이픈을 지우고 비교한다.

const norm = (v) => String(v || "").toLowerCase();
const digitsOnly = (v) => String(v || "").replace(/[^0-9]/g, "");

// 회사 매칭 — 회사명 부분 일치 또는 사업자번호 숫자 부분 일치
export function matchesPartner(partner, query) {
  const q = norm(query);
  if (!q) return true;
  if (norm(partner.companyName).includes(q)) return true;
  const qDigits = digitsOnly(q);
  if (!qDigits) return false;
  return digitsOnly(partner.businessNumber).includes(qDigits);
}

// 계정 매칭 — 아이디·이름·이메일 부분 일치
export function matchesUser(user, query) {
  const q = norm(query);
  if (!q) return true;
  return (
    norm(user.loginId).includes(q) || norm(user.name).includes(q) || norm(user.email).includes(q)
  );
}

// 검색 결과 행 만들기.
//   회사가 걸리면 그 회사의 전체 계정, 계정만 걸리면 그 회사 + 걸린 계정만.
//   hit=true 는 "계정 검색으로 걸린 회사" — 기본 펼침 상태로 보여 준다.
// 반환: [{ partner, users, hit }]
export function buildPartnerRows(partners, usersByPartner, query) {
  const q = norm(String(query || "").trim());
  if (!q) {
    return partners.map((p) => ({ partner: p, users: usersByPartner[p.id] || [], hit: false }));
  }
  const rows = [];
  partners.forEach((p) => {
    const mine = usersByPartner[p.id] || [];
    if (matchesPartner(p, q)) {
      rows.push({ partner: p, users: mine, hit: false });
      return;
    }
    const matched = mine.filter((u) => matchesUser(u, q));
    if (matched.length) rows.push({ partner: p, users: matched, hit: true });
  });
  return rows;
}

// 회사 id → 소속 계정 목록
export function groupUsersByPartner(users) {
  const map = {};
  (users || []).forEach((u) => {
    if (!map[u.partnerId]) map[u.partnerId] = [];
    map[u.partnerId].push(u);
  });
  return map;
}
